export enum ManageMode {
  create = 'create',
  edit = 'edit',
  view = 'view',
}
